import React, {useRef} from 'react'
import texture from '../Assets/Imgs/zeroz full logo.jpg';

import {useLoader, useFrame} from '@react-three/fiber'
import { TextureLoader } from 'three/src/loaders/TextureLoader'

function Sphere() {
  const mesh = useRef(null);
  useFrame(() => (mesh.current.rotation.x = mesh.current.rotation.y += 0.01));
  const textureMap = useLoader(TextureLoader, texture);

  return (
    <>
    <mesh visible userData={{ hello: 'world' }} ref={mesh}>
    {/*<mesh visible userData={{ hello: 'world' }} position={[-1, 0, -1]} rotation={[0, 0, 0]}> */}
        <sphereGeometry args={[2, 32]} />
        <meshStandardMaterial  map={textureMap}  />
    </mesh>
    </>
  )
}

export default Sphere